var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header-nav',{attrs:{"headerLinks":_vm.websiteData.headerLinks}}),_vm._v(" "),_c('welcome',{attrs:{"welcomePage":_vm.websiteData.welcomePage}}),_vm._v(" "),_c('projects',{attrs:{"projects":_vm.websiteData.projects}}),_vm._v(" "),_c('about',{attrs:{"about":_vm.websiteData.about}}),_vm._v(" "),_c('skillsets',{attrs:{"skillsets":_vm.websiteData.skillsets}}),_vm._v(" "),_c('contact',{attrs:{"contact":_vm.websiteData.contactInfo}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-655394bd","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/main-page.vue
// module id = 74
// module chunks = 0